"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsSearchModel = instanceOfProductPromotionsSearchModel;
exports.ProductPromotionsSearchModelFromJSON = ProductPromotionsSearchModelFromJSON;
exports.ProductPromotionsSearchModelFromJSONTyped = ProductPromotionsSearchModelFromJSONTyped;
exports.ProductPromotionsSearchModelToJSON = ProductPromotionsSearchModelToJSON;
exports.ProductPromotionsSearchModelToJSONTyped = ProductPromotionsSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsSearchModel interface.
 */
function instanceOfProductPromotionsSearchModel(value) {
    return true;
}
function ProductPromotionsSearchModelFromJSON(json) {
    return ProductPromotionsSearchModelFromJSONTyped(json, false);
}
function ProductPromotionsSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'wsppPromotionsName': json['wsppPromotionsName'] == null ? undefined : json['wsppPromotionsName'],
        'wsppPromotionsCode': json['wsppPromotionsCode'] == null ? undefined : json['wsppPromotionsCode'],
        'wsppPromotionsDateS': json['wsppPromotionsDateS'] == null ? undefined : json['wsppPromotionsDateS'],
        'wsppPromotionsDateE': json['wsppPromotionsDateE'] == null ? undefined : json['wsppPromotionsDateE'],
        'wssWebSiteName': json['wssWebSiteName'] == null ? undefined : json['wssWebSiteName'],
        'wsppUseStatus': json['wsppUseStatus'] == null ? undefined : json['wsppUseStatus'],
    };
}
function ProductPromotionsSearchModelToJSON(json) {
    return ProductPromotionsSearchModelToJSONTyped(json, false);
}
function ProductPromotionsSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'wsppPromotionsName': value['wsppPromotionsName'],
        'wsppPromotionsCode': value['wsppPromotionsCode'],
        'wsppPromotionsDateS': value['wsppPromotionsDateS'],
        'wsppPromotionsDateE': value['wsppPromotionsDateE'],
        'wssWebSiteName': value['wssWebSiteName'],
        'wsppUseStatus': value['wsppUseStatus'],
    };
}
